// extracted by mini-css-extract-plugin
export default {"mCard":"oA-z","image":"pA-z","imageNoBackground":"qA-z","imageHasCategory":"rA-z","fullWidth":"sA-z"};